import MaskedInput from 'react-text-mask';
import React from 'react';

export default function ArrestTransactionTextMask(props) {
  const { inputRef, ...other } = props;

  // Dynamic mask function to allow A-Z, 0-9, and hyphen, with max length of 12
  const createMask = (rawValue) => {
    const cleanValue = rawValue.toUpperCase().replace(/[^A-Z0-9-]/g, ''); // Remove invalid characters

    // Generate mask dynamically based on length
    return Array.from({ length: Math.min(cleanValue.length, 12) }).map(() => /[A-Z0-9-]/);
  };

  return (
    <MaskedInput
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={createMask}
      placeholderChar={' '}
      showMask
      guide={false}
    />
  );
}
